import { render } from "./PersonalitiesMediaPublications.vue?vue&type=template&id=7d607c8e"
import script from "./PersonalitiesMediaPublications.vue?vue&type=script&lang=js"
export * from "./PersonalitiesMediaPublications.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__